export default __webpack_public_path__ + "static/media/war.ad5bee3e.jpg";